module.exports = __webpack_public_path__ + "img/2595@3x.2cd4913e.png";